import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
// import { TooltipModule } from 'ngx-bootstrap';
// import { GrdFilterPipe } from './grd-filter-pipe';
// import { FooterComponent } from './footer.component';
// import { DataTableModule } from "angular-6-datatable";
// import { CustomFormsModule } from 'ngx-custom-validators';
// import { AboutUsComponent } from './aboutus/aboutus.component';
import { DatePipe } from '@angular/common';
import { MainComponent } from './main.component';
// import { AgGridModule } from 'ag-grid-angular';
// import { NgBusyModule} from 'ng-busy';
import { HotkeyModule } from 'angular2-hotkeys';
import { SharedModule } from "../shared/shared.module";
// import { mastersRouteComponent } from './masters/mastersRoute.component';


import { PayrollComponent } from './payroll/payroll.component';
import { EmployeesComponent } from './payroll/employees.component';

import { NgbDateCustomParserFormatter } from "../shared/services/dateformat";

// import { ToolsComponent } from './tools/tools.component';
// import { GeneralComponent } from './tools/general.component';
// import { InventoryComponent } from './inventory/inventory.component';
// import {BinComponent} from './inventory/bin.component';
// import {WarehouseComponent} from './inventory/warehouse.component';
// import { CompanyComponent } from './tools/company.component';
// import { RoutesComponent } from './tools/routes.component';
// import { DeliveryBoyComponent } from './tools/deliveryboy.component';
// import { TransporterComponent } from './tools/transporter.component';
// import { GeneralMenuComponent } from './tools/generalMenu.component';
// import { ErpProviderComponent } from './tools/erpprovider.component';
// import { ExcelConfigComponent } from './tools/excelconfig.component';
// import { UnitComponent } from './tools/unit.component';
// import { UserGroup } from './tools/usergroup.component';
// import { UserRight } from './tools/userright.component';
// import { CollectionBoy } from './tools/collectionboy.component';
// import { SalesMan } from './tools/salesman.component';
// import { Counter } from './tools/counter.component';
// import { UserMaster } from './tools/usermaster.component';
// import { FinancialComponent } from './financial/financial.component';
// import { Bank } from './financial/bank.component';
// import { BankAcType } from './financial/bankactype.component';
// import { PaymentTerms } from './financial/paymentterms.component';
// import { BankAccount } from './financial/bankaccount.component';
// import { GlGroup } from './financial/glgroup.component';
// import { GlAccount } from './financial/glaccount.component';

// import { SalesComponent } from './sales/sales.component';
// import { SalesOrderComponent } from './sales/salesorder.component';
// import { DeliveryChallanComponent } from './sales/deliverychallan.component';
// import { SalesInvoiceComponent } from './sales/salesinvoice.component';
// import { SalesReturnComponent } from './sales/salesreturn.component';
// import { SalesBreakageOrExpiryComponent } from './sales/salesBreakageOrExpiry.component';


// import { PurchaseComponent } from './purchase/purchase.component';
// import { GoodsReceiptComponent } from './purchase/GoodsReceipt.component';
// import { PurchaseOrderComponent } from './purchase/purchaseorder.component';
// import { PurchaseReturnComponent } from './purchase/purchaseReturn.component';
// import { PurchaseBreakageOrExpiryComponent } from './purchase/purchaseBreakageOrExpiry.component';

// import { FinanceComponent } from './finances/finances.component';
// import { JournalVoucherComponent } from './finances/journalvoucher.component';
// import { AccountClearingComponent } from './finances/accountclearing.component';
// import { BankReconcilationComponent } from './finances/bankreconcilation.component';
// import { ContraEntryComponent } from './finances/contraentry.component';
// import { CustomerNoteComponent } from './finances/customernote.component';
// import { MiscInvoiceCustomerComponent } from './finances/miscinvoicecustomer.component';
// import { MiscInvoiceVendorComponent } from './finances/miscinvoicevendor.component';
// import { PaymentComponent } from './finances/payment.component';
// import { ReceiptComponent } from './finances/receipt.component';
// import { VendorNoteComponent } from './finances/vendornote.component';

// import { OnlyNumber } from './validation/onlynumber.directive';
// import { FilterPipe} from './validation/filter.pipe';
// import { NgDatepickerModule } from 'ng2-datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthGuard } from './../../components/auth/auth-guard.service';

import { AppServiceService } from './services/product.service';
import { UtilityService } from '../shared/services/Utility.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { MainMenuService } from './services/menuservice.service';
import { GrdFilterPipe } from './grd-filter.pipe';
import { UserStampService } from './services/userstamp.service';
import { WarehouseDashboardComponent } from './WarehouseDashboard.component';
import { OrderTrackerDashboardComponent } from './OrderTrackerDashboard.component';


export const ROUTES: Routes = [
    { path: 'home', component: MainComponent, canActivate: [AuthGuard], data: { title: 'Dashboard' } },
    { path: 'home/warehousedashboard', component: WarehouseDashboardComponent, canActivate: [AuthGuard], data: { title: 'Warehouse Dashboard' } },
    { path: 'home/ordertrackerdashboard', component: OrderTrackerDashboardComponent, canActivate: [AuthGuard], data: { title: 'Order Tracker Dashboard' } },
    // { path: 'aboutus', component: AboutUsComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},

    // { path: 'tools', component: ToolsComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./tools/tools.module')['ToolsModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) },canActivate: [AuthGuard]},

    // { path: 'tools/general', component: GeneralComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/company', component: CompanyComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/routes', component:RoutesComponent, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/general/deliveryboy', component: DeliveryBoyComponent, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/general/transporter', component: TransporterComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/unit', component: UnitComponent, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/general/userGroup', component: UserGroup, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/userRight', component: UserRight, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/general/collectionBoy', component: CollectionBoy, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/salesMan', component: SalesMan, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/general/counter', component: Counter, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/general/user', component: UserMaster, pathMatch: 'full',canActivate: [AuthGuard] },

    // { path: 'tools/financial', component: FinancialComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/financial/bank', component: Bank, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/financial/bankAcType', component: BankAcType, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/financial/paymentTerms', component: PaymentTerms, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/financial/bankAccount', component: BankAccount, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/financial/glGroup', component: GlGroup, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'tools/financial/ledger', component: GlAccount, pathMatch: 'full' ,canActivate: [AuthGuard]},

    // { path: 'tools/inventory', component: InventoryComponent, pathMatch: 'full', canActivate: [AuthGuard] },
    // { path: 'tools/inventory/bin', component: BinComponent, pathMatch: 'full', canActivate: [AuthGuard] },
    // { path: 'tools/inventory/warehouse', component: WarehouseComponent, pathMatch: 'full', canActivate: [AuthGuard] },

    // { path: 'tools/configuration', component: ExcelConfigComponent, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'tools/configuration/erp', component: ErpProviderComponent, pathMatch: 'full',canActivate: [AuthGuard] },

    { path: 'master', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./masters/master.module')['MasterModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'master');}) }, canActivate: [AuthGuard], data: { title: 'Master' } },
    { path: 'sales', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./sales/sales.module')['SalesModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'salse');}) }, canActivate: [AuthGuard], data: { title: 'Sales' } },
    { path: 'purchase', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./purchase/purchase.module')['PurchaseModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'purchase');}) }, canActivate: [AuthGuard], data: { title: 'Purchase' } },
    { path: 'tools', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./tools/tools.module')['ToolsModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'tools');}) }, canActivate: [AuthGuard], data: { title: 'Tools' } },
    { path: 'payroll', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./payroll/payroll.module')['PayrollModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'payroll');}) }, canActivate: [AuthGuard], data: { title: 'Payroll' } },
    { path: 'finances', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./finances/finances.module')['FinancesModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'finances');}) }, canActivate: [AuthGuard], data: { title: 'Finances' } },
    { path: 'settings', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./settings/settings.module')['SettingsModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'settings');}) }, canActivate: [AuthGuard], data: { title: 'Settings' } },
    { path: 'reports', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./reports/reports.module')['ReportsModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'reports');}) }, canActivate: [AuthGuard], data: { title: 'Reports' } },

    // { path: 'payroll', component: PayrollComponent, pathMatch: 'full' },
    // { path: 'payroll/employees', component: EmployeesComponent, pathMatch: 'full' },

    // { path: 'sales', component: SalesComponent, pathMatch: 'full',canActivate: [AuthGuard] },
    // { path: 'sales/salesorder', component: SalesOrderComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'sales/deliverychallan', component: DeliveryChallanComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'sales/salesinvoice', component: SalesInvoiceComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'sales/salesreturn', component: SalesReturnComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'sales/salesBreakageOrExpiry', component: SalesBreakageOrExpiryComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},

    // { path: 'finances', component: FinanceComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/voucher', component: JournalVoucherComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/payment', component: PaymentComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/receipt', component: ReceiptComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/contraentry', component: ContraEntryComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/accountclearing', component: AccountClearingComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/vendornote', component: VendorNoteComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/customernote', component: CustomerNoteComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/miscinvoicevendor', component: MiscInvoiceVendorComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/miscinvoicecustomer', component: MiscInvoiceCustomerComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'finances/bankreconcilation', component: BankReconcilationComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},

    // { path: 'purchase', component: PurchaseComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'purchase/goodsReceipt', component: GoodsReceiptComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'purchase/purchaseOrder', component: PurchaseOrderComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'purchase/purchaseReturn', component: PurchaseReturnComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},
    // { path: 'purchase/purchaseBreakageOrExpiry', component: PurchaseBreakageOrExpiryComponent, pathMatch: 'full' ,canActivate: [AuthGuard]},


    { path: '**', redirectTo: '/login', pathMatch: 'full', canActivate: [AuthGuard] }
];


@NgModule({
    imports: [
        BrowserModule,
        SharedModule,
        // NgSelectModule,
        FormsModule,
        // CustomFormsModule,
        ReactiveFormsModule,
        // DataTableModule,
        RouterModule.forChild(ROUTES),
        // AgGridModule.withComponents(null),
        // TooltipModule.forRoot(),
        // NgBusyModule,
        HotkeyModule.forRoot(),
        //GrdFilterPipe,
        // NgDatepickerModule,
        // NgbModule
    ],
    declarations: [

        MainComponent,
        GrdFilterPipe,
        // FooterComponent,
        // AboutUsComponent,
        // RoutesComponent,
        // DeliveryBoyComponent,
        // CompanyComponent,
        // mastersRouteComponent,
        // ToolsComponent,
        // GeneralComponent,
        // FinancialComponent,
        // MasterComponent,
        // ProductComponent,
        // ProductListComponent,
        // VendorComponent,
        // VendorlistComponent,
        // CustomerComponent,
        // CustomerlistComponent,
        // HsnComponent,
        // PurchaseComponent,
        // GoodsReceiptComponent,
        // TransporterComponent,
        // GeneralMenuComponent,
        // UnitComponent,
        // UserGroup,
        // UserRight,
        // CollectionBoy,
        // SalesMan,
        // Counter,
        // UserMaster,
        // Bank,
        // BankAcType,
        // PaymentTerms,
        // BankAccount,
        // GlGroup,
        // GlAccount,
        // SalesComponent,
        // SalesInvoiceComponent,
        // SalesOrderComponent,
        // PurchaseOrderComponent,
        // DeliveryChallanComponent,
        // // OnlyNumber,
        // // FilterPipe,
        // // SequenceComponent,
        // PayrollComponent,
        // SalesReturnComponent,
        // EmployeesComponent,
        // SalesBreakageOrExpiryComponent,
        // PurchaseReturnComponent,
        // PurchaseBreakageOrExpiryComponent,
        // ErpProviderComponent,
        // ExcelConfigComponent,
        // FinanceComponent,
        // JournalVoucherComponent,
        // AccountClearingComponent,
        // BankReconcilationComponent,
        // ContraEntryComponent,
        // CustomerNoteComponent,
        // MiscInvoiceCustomerComponent,
        // MiscInvoiceVendorComponent,
        // PaymentComponent,
        // ReceiptComponent,
        // VendorNoteComponent,
        // BinComponent,
        // InventoryComponent,
        // WarehouseComponent
    ],

    exports: [
        MainComponent,
        NgbModule
        // AboutUsComponent,
        // RoutesComponent,
        // DeliveryBoyComponent,
        // CompanyComponent,
        // mastersRouteComponent,
        // ToolsComponent,
        // GeneralComponent,
        // FinancialComponent,
        // MasterComponent,
        // ProductComponent,
        // ProductListComponent,
        // VendorComponent,
        // VendorlistComponent,
        // CustomerComponent,
        // CustomerlistComponent,
        // HsnComponent,
        // PurchaseComponent,
        // GoodsReceiptComponent,
        // TransporterComponent,
        // GeneralMenuComponent,
        // UnitComponent,
        // UserGroup,
        // UserRight,
        // CollectionBoy,
        // SalesMan,
        // Counter,
        // UserMaster,
        // Bank,
        // BankAcType,
        // PaymentTerms,
        // BankAccount,
        // GlGroup,
        // GlAccount,
        // SalesComponent,
        // SalesInvoiceComponent,
        // SalesOrderComponent,
        // PurchaseOrderComponent,
        // DeliveryChallanComponent,
        // // SequenceComponent,
        // PayrollComponent,
        // SalesReturnComponent,
        // EmployeesComponent,
        // SalesBreakageOrExpiryComponent,
        // PurchaseReturnComponent,
        // PurchaseBreakageOrExpiryComponent,
        // ErpProviderComponent,
        // ExcelConfigComponent,
        // FinanceComponent,
        // JournalVoucherComponent,
        // AccountClearingComponent,
        // BankReconcilationComponent,
        // ContraEntryComponent,
        // CustomerNoteComponent,
        // MiscInvoiceCustomerComponent,
        // MiscInvoiceVendorComponent,
        // PaymentComponent,
        // ReceiptComponent,
        // VendorNoteComponent,
        // BinComponent,
        // InventoryComponent,
        // WarehouseComponent,
        // GrdFilterPipe
    ],
    providers: [
        UtilityService,
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
        MainMenuService,
        UserStampService
        ,DatePipe
        // {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
    ]
})
export class MainModule { }
